import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { RegularSection } from '@/components/Layouts'

const CARD_GRID_SX = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  border: '2px solid var(--primary-color)',
  borderRadius: 4,
  p: 2,
  minHeight: { xs: 130 },
}

interface Card {
    title?: string
    subtitle?: string
}

interface Content {
    cards?: Card[]
}

interface S3_L2_2Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_L2_2Props) => {
    const { content = {} } = props
    const { cards = [] } = content
    return (
        <RegularSection aria-label='S3_L2_2' >

            <Grid
                container
                spacing={2}
            >
                {cards.map((card, index) => (
                    <Grid
                        key={index}
                        size={{ xs: 12, md: 6, lg: 4 }}
                        sx={CARD_GRID_SX}
                    >
                        <Typography
                            variant='h3'
                            sx={{ color: 'primary.main' }}
                        >
                            {'0' + (index + 1)}
                        </Typography>
                        <Typography variant='h3'>{card.title}</Typography>
                        <Typography variant='body2'>{card.subtitle}</Typography>
                    </Grid>
                ))}
            </Grid>
        </RegularSection>
    )
}

export default Index
